var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatures2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 786,
    viewBox: "0 0 750 786",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1068_456",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 750,
    height: 786
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.558594,
    y: 0.797852,
    width: 749.229,
    height: 785.195,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1068_456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-52.6084 12.5152V532.813C-52.6084 542.817 -56.6196 552.41 -63.7596 559.483C-70.8996 566.557 -80.5835 570.531 -90.681 570.531H-161.256C-171.336 570.531 -181.003 574.497 -188.13 581.558C-195.258 588.619 -199.262 598.196 -199.262 608.182V749.147C-199.262 759.133 -195.258 768.709 -188.13 775.77C-181.003 782.831 -171.336 786.798 -161.256 786.798H560.594C570.674 786.798 580.341 782.831 587.468 775.77C594.595 768.709 598.6 759.133 598.6 749.147V608.381C598.6 603.431 599.585 598.529 601.499 593.957C603.413 589.385 606.219 585.231 609.755 581.734C613.291 578.237 617.489 575.465 622.108 573.577C626.727 571.689 631.676 570.721 636.672 570.73H711.781C716.795 570.73 721.759 569.747 726.388 567.839C731.016 565.93 735.218 563.133 738.751 559.608C742.284 556.084 745.077 551.902 746.972 547.303C748.866 542.704 749.822 537.78 749.787 532.813V12.5152C749.796 7.56526 748.82 2.66213 746.914 -1.91356C745.007 -6.48926 742.209 -10.6477 738.679 -14.151C735.149 -17.6542 730.956 -20.4335 726.341 -22.3298C721.726 -24.2261 716.778 -25.2022 711.781 -25.2021H-14.6028C-19.5994 -25.2022 -24.547 -24.2261 -29.1624 -22.3298C-33.7778 -20.4335 -37.9705 -17.6542 -41.5005 -14.151C-45.0305 -10.6477 -47.8287 -6.48926 -49.7347 -1.91356C-51.6408 2.66213 -52.6172 7.56526 -52.6084 12.5152Z",
    fill: "#C4EAFA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures2);
export default __webpack_public_path__ + "static/media/features2.eab4faf3ef67503b20bd13a3df7be4b8.svg";
export { ForwardRef as ReactComponent };